// extracted by mini-css-extract-plugin
export var container = "_d0-0";
export var popoverContent = "_d0-1";
export var tosLink = "_d0-2";